<page-toolbar [pageActions]="pageActions" [title]="pageTitle"></page-toolbar>

<page-content *ngIf="!isLoading">
  <div class="row">
    <mat-card appearance="outlined">
      <mat-card-title>{{compositionApp.name}}</mat-card-title>
      <p>Icon: {{compositionApp.icon}}
        <ibex-icon [name]="compositionApp.icon"></ibex-icon>
      </p>

      <mat-tab-group *ngIf="compositionApp.translations && compositionApp.translations.length" class="language-tabs-container">
        <mat-tab *ngFor="let translation of compositionApp.translations" label="{{translation.language}}">
          <composition-app-detail-menu-items
            (save)="saveCompositionApp($event)"
            [importerByMenuItems]=importerByMenuItem
            [language]="translation.language"
            [translation]=translation></composition-app-detail-menu-items>
        </mat-tab>
      </mat-tab-group>
    </mat-card>
  </div>

</page-content>
